import { TechnicalError } from '../../../common/errors';
import { CancellableResult } from '../../../common/result';
import { CancellableResultDetail } from '../../../common/result/cancellableResult';
import { AuthenticationResult, SearchAuthenticationResult } from '../faceAuthentication';
import { FacetecResult, ProcessorResponse } from './facetecProcessor';

const missingIdentityAuthTokenError = (identityAuthId: string): AuthenticationResult =>
  CancellableResult.failed(
    new TechnicalError(
      `Unable to complete facetec operation successfully, result identity auth token is null. IdentityAuthId: [${identityAuthId}]`,
    ),
  );

/** Return successful authentication result from processor response. If identity auth token is missing, return error result */
const successResult = (
  processorResponse: ProcessorResponse,
  detail?: CancellableResultDetail,
): AuthenticationResult => {
  if (!processorResponse.identityAuthToken) {
    return missingIdentityAuthTokenError(processorResponse.identityAuthId);
  }

  return CancellableResult.successful(
    {
      base64SelfieImage: processorResponse.base64SelfieImage,
      identityAuthId: processorResponse.identityAuthId,
      identityAuthToken: processorResponse.identityAuthToken,
    },
    detail,
  );
};

/** map the given facetec result to a authentication result  */
const mapAuthenticationResult = (result: FacetecResult): AuthenticationResult => {
  if (result.isCancelled()) {
    return CancellableResult.cancelled(result.getDetail());
  }

  if (result.isFailed()) {
    return CancellableResult.failed(result.failure(), result.getDetail());
  }

  return successResult(result.success(result.getDetail()), result.getDetail());
};

/** map the given facetec result to a uniqueness authentication result */
const mapSearchResult = (result: FacetecResult): SearchAuthenticationResult => {
  if (result.isCancelled()) {
    return CancellableResult.cancelled(result.getDetail());
  }

  if (result.isFailed()) {
    return CancellableResult.failed(result.failure(), result.getDetail());
  }

  const processorResponse = result.success(result.getDetail());

  return CancellableResult.successful({
    identityAuthId: processorResponse.identityAuthId,
    identityAuthToken: processorResponse.identityAuthToken,
    searchMatches: processorResponse.searchMatches || [],
  });
};

export default {
  mapAuthenticationResult,
  mapSearchResult,
};
